//Core
import React from "react"

//styles
import style from "./style.module.scss"

const MenuList = ({ menu = [] }) => {
  return (
    <nav role="navigation" className={style.Menu}>
      <ul className={style.list}>
        {menu.map(({ link, text }) => (
          <li key={link}>
            <a href={link}>{text}</a>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default MenuList
